import StarRating from './star-rating.vue';

export default StarRating;



// WEBPACK FOOTER //
// ./src/vendor/vue-star-rating/index.js